<template>
    <div class="page-wrapper">
        <Header/>
        <div class="wrapper">
            <div class="page">
                <div class="container">
                    <div class="page-title">Как пользоваться</div>
                    <div class="articles-list visibility">
                        <div class="article"
                             :class="{'article-no-access': article.onlyAuth || article.onlyPaid || article.onlyPro}"
                             v-for="(article, index) in articles">
                            <div class="image" :style="{'background-image': `url(${getArticleImage(article)})`}">
                                <div v-if="article.onlyPaid || article.onlyPro">
                                    <span class="read">
                                        <div class="vcenter-container">
                                            <div class="vcenter">Подключите <router-link :to="{name: 'Tariff'}"
                                                                                         target="_blank">тариф PRO</router-link> для просмотра этой статьи</div>
                                        </div>
                                    </span>
                                </div>
                                <div v-if="article.onlyAuth">
                                    <span class="read">
                                        <div class="vcenter-container">
                                            <div class="vcenter"><router-link :to="{name: 'Login'}" target="_blank">Авторизуйтесь</router-link><br> для просмотра этой статьи</div>
                                        </div>
                                    </span>
                                </div>
                                <router-link v-else
                                             :to="{name: 'Article', params: {code: article.code}}">
                                    <span class="read">
                                        <div class="vcenter-container">
                                            <div class="vcenter">читать <i class="fa fa-long-arrow-right"></i></div>
                                        </div>
                                    </span>
                                </router-link>
                            </div>
                            <div class="date">{{ formatDate(article.date) }}</div>
                            <div class="title">
                                <span v-if="article.onlyAuth || article.onlyPaid || article.onlyPro">
                                    {{ formatHeader(article.header, index) }}
                                </span>
                                <router-link v-else
                                             :to="{name: 'Article', params: {code: article.code}}" title="Читать">
                                    {{ formatHeader(article.header, index) }}
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <pagination
                            :currentPage="currentPage"
                            :totalPages="totalPages"
                            @load-page="loadArticles"/>
                </div>
            </div>
            <div class="page-buffer"></div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import constants from '@/constants';
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import moment from 'moment';
    import Pagination from '@/components/Pagination';

    export default {
        name: "Blog",

        components: {
            Header, Footer, Pagination
        },

        data() {
            return {
                articles: [],
                currentPage: 0,
                totalPages: 0,
                pageSize: 1,

                defaultArticleImage: require('@/image/default_article_image.jpg')
            }
        },

        computed: {
            userLoggedIn() {
                let token = this.$store.getters.token;
                return !!token && token.length > 0;
            },

            currentSubscription() {
                return this.$store.getters.currentSubscription;
            }
        },

        async created() {
            if (!!this.userLoggedIn) {
                await this.$store.dispatch('getCurrentSubscription');
            }

            let page = this.$route.query.page || 0;
            await this.loadArticles(page);
        },

        methods: {
            async loadArticles(page) {
                let articlesPage = await this.$store.dispatch('listArticles', [page || 0]);
                if (!articlesPage)
                    return;

                let onlyPro = (!this.currentSubscription || this.currentSubscription.tariff !== constants.tariff.PRO);
                let onlyPaid = (!this.currentSubscription || ![constants.tariff.STANDARD, constants.tariff.PRO].includes(this.currentSubscription.tariff));
                let onlyAuth = !this.userLoggedIn;

                this.articles = articlesPage.content.map(article => {
                    return Object.assign(article, {
                        onlyPro: onlyPro && article.status === constants.articleStatus.ONLY_PRO,
                        onlyPaid: onlyPaid && article.status === constants.articleStatus.ONLY_PAID,
                        onlyAuth: onlyAuth && article.status === constants.articleStatus.ONLY_AUTH
                    });
                });
                this.currentPage = articlesPage.pageable.pageNumber;
                this.totalPages = articlesPage.totalPages;
                this.pageSize = articlesPage.pageable.pageSize;
            },

            formatHeader(header, index) {
                let articleNum = this.pageSize * this.currentPage + index + 1;
                return `#${articleNum}|${header}`;
            },

            formatDate(date) {
                return moment(date).format("DD.MM.YYYY");
            },

            getArticleImage(article) {
                if (!!article.hasImage)
                    return process.env.VUE_APP_GLOBAL_URL + `/document/article-image/${article.id}`;
                else
                    return this.defaultArticleImage;
            }
        },
    }
</script>